import GoogleMapReact from "google-map-react"
import styles from "./flowerfieldRegister.module.css"
import { useRef, useState, useEffect } from "react"
import {
  updateFlowerfield,
  fetchFlowerfield,
  addFlowerfield,
  updateFlowerfieldContactInfo
} from "@/lib/api/flowerfields"
import Button from "@/common/button/button"
import { useRouter } from "next/router"
import { FormProvider, useForm } from "react-hook-form"
import getInputValidationClasses from "@/lib/helpers/getInputValidationClasses"
import isEmail from "validator/lib/isEmail"
import { ErrorMessage } from "@/components/checkout-form/errorMessage"
import InputGroup from "@/common/form/inputGroup"
import Label from "@/common/form/label"
import { Spinner } from "@/components/common/loading/spinner"
import Block from "@/components/wrappers/block"
import FileBase64 from "react-file-base64"
import Modal from "react-modal"
import Checkmark from "@/components/common/icons/checkmark"
import Close from "@/components/common/icons/close"
import modalStyles from "@/components/base/popup/popup.module.css"
import classNames from "classnames"
import { Checkbox } from "@/common/form/checkbox"
import checkboxStyles from "@/common/form/checkbox.module.css"
import { Datepicker } from "@/common/datepicker/datepicker"
import cx from "classnames"
import { ActivityControl } from "./activity-control"
import FileUpload from "./upload.js"
import { Caret } from "@/common/icons/caret"
import CalendarIcon from "@/common/icons/calendar"
import Edit from "@/common/icons/user/edit"
import Image from "next/legacy/image"
import ReCAPTCHA from "react-google-recaptcha"
import { pushDataLayer } from "@/lib/helpers/tagManager"

export default function VlbaRegister({ block }) {
  const distance = {
    id: 0,
    mapHandler: {
      map: null,
      drawingManager: null,
      polyline: null
    },
    data: {
      title: "",
      description: "",
      type: 0,
      status: 1,
      meters: 0,
      coordinates: [],
      hasContacted: false,
      hasOrganization: false,
      organization: false,
      isWay: false,
      isMunicipality: false,
      activities: [],
      inventory: [],
      media: [],
      municipality: 0
    },
    errors: {}
  }
  const { query } = useRouter()
  const [invalidToken, setInvalidToken] = useState(false)
  const [invalidPassword, setInvalidPassword] = useState(false)
  const [loading, setLoading] = useState(true)
  const [token, setToken] = useState(false)
  const [login, setLogin] = useState(false)
  const [allTheDistances, setAllTheDistances] = useState([distance])
  const [coordinates, setCoordinates] = useState([])
  const [password, setPassword] = useState("")
  const [pageType, setPageType] = useState("new")
  const [currentStep, setCurrentStep] = useState("contact")
  const [currentDistance, setCurrentDistance] = useState(0)
  const [pageUpdatedSuccess, setPageUpdatedSuccess] = useState(false)
  const [uploadErrors, setUploadErrors] = useState(false)
  const [helpModalIsOpen, setHelpModalIsOpen] = useState(false)
  const [selectedSpecies, setSelectedSpecies] = useState(0)
  const [customSpecies, setCustomSpecies] = useState("")
  const [selectedFrequency, setSelectedFrequency] = useState(0)

  const [currentDistanceIndex, setCurrentDistanceIndex] = useState(0)
  const [currentSpeciesIndex, setCurrentSpeciesIndex] = useState(0)

  const [addSpeciesToMapModalIsOpen, setAddSpeciesToMapModalIsOpen] =
    useState(false)
  const [currentInventory, setCurrentInventory] = useState(-1)
  const [currentInventoryDate, setCurrentInventoryDate] = useState(false)

  const [newActivityError, setNewActivityError] = useState(false)
  const [newActivityDate, setNewActivityDate] = useState(false)
  const [newActivityItem, setNewActivityItem] = useState(0)
  const [newActivityStatus, setNewActivityStatus] = useState("planned")
  const [newActivityUploads, setNewActivityUploads] = useState([])
  const [newActivityDescription, setNewActivityDescription] = useState("")
  const [currentActivityIndex, setCurrentActivityIndex] = useState(-1)

  const [saveErrors, setSaveErrors] = useState(false)
  const [distanceError, setDistanceError] = useState(false)

  let markers = []

  const mapKey = process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY
  const router = useRouter()
  const types = [
    {
      value: "private",
      name: "Enskild väg"
    },
    {
      value: "municipal",
      name: "Kommunal väg"
    },
    {
      value: "state",
      name: "Statlig väg (endast länsstyrelse)"
    }
  ]

  const status = [
    {
      value: "started",
      name: "Påbörjad"
    },
    {
      value: "living",
      name: "Blomrik"
    }
  ]

  const organizations = block.attrs.organizations ?? []
  const municipalities = block.attrs.municipalities ?? []

  const activityStatuses = [
    {
      label: "Planerad",
      value: "planned",
      defaultChecked: false
    },
    {
      label: "Genomförd",
      value: "completed",
      defaultChecked: false
    }
  ]

  const species = block.attrs.species
  const frequencies = block.attrs.frequencies
  const soilProperties = block.attrs.soilProperties
  const adjacentLand = block.attrs.adjacentLand
  const negativeImpact = block.attrs.negativeImpact
  const distanceActivities = block.attrs.activities

  // Form
  const methods = useForm({
    mode: "onChange"
  })

  const {
    formState,
    control,
    register,
    handleSubmit,
    setValue,
    trigger,
    getValues,
    watch
  } = methods
  let { errors, isValid } = formState
  const publicEmail = watch("publicEmail")

  const recaptchaRef = useRef()
  const siteKey = process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY

  // Login or use token
  useEffect(() => {
    if (query.token !== undefined) {
      loadData("token", query.token)
    } else {
      if (query.login !== undefined) {
        setLogin(true)
        setCurrentStep("login")
      }
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query])

  // Check if the token is valid
  const loadData = async (type, token) => {
    setLoading(true)
    setInvalidToken(false)
    setInvalidPassword(false)
    const response = await fetchFlowerfield(type, token)

    if (response.fetchFlowerfield.success) {
      setAllTheDistances([])
      setValue("name", response.fetchFlowerfield.contactInfo.name)
      setValue("email", response.fetchFlowerfield.contactInfo.email)
      setValue("publicEmail", response.fetchFlowerfield.contactInfo.publicEmail)
      const savedDistances = response.fetchFlowerfield.distances.map(
        (current, index) => {
          return {
            ...distance,
            ...{
              id: index,
              data: current
            }
          }
        }
      )

      setAllTheDistances(savedDistances)
      setPageType("update")
      setCurrentStep("confirm")
      setLogin(false)
      setToken(response.fetchFlowerfield.token)
    } else {
      if (type === "token") {
        setInvalidToken(true)
      } else {
        setInvalidPassword(true)
      }
    }
    setLoading(false)
  }

  // To update coordinates on map
  useEffect(() => {
    let items = [...allTheDistances]

    if (coordinates.key !== undefined) {
      coordinates.update.errors = items[coordinates.key].errors
      coordinates.update.errors.coordinates = false
      items[coordinates.key] = {
        ...items[coordinates.key],
        ...coordinates.update
      }
    }

    setAllTheDistances(items)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coordinates])

  // Add a new distance
  function addNewDistance() {
    let newDistance = distance
    newDistance.id = allTheDistances.length
    setAllTheDistances((allTheDistances) => [...allTheDistances, newDistance])
    setCurrentDistance(allTheDistances.length)
    setCurrentDistanceIndex(allTheDistances.length)
    setCurrentSpeciesIndex(allTheDistances.length)
    setCurrentStep("add")
  }

  // Delete a distance
  function deleteDistance(key) {
    let items = [...allTheDistances]
    items.splice(key, 1)
    setAllTheDistances(items)
  }

  // Remove a polyline from a distance
  function removePolyline(key) {
    allTheDistances[key].mapHandler.drawingManager.setOptions({
      drawingControl: true,
      drawingMode: window.google.maps.drawing.OverlayType.POLYLINE,
      drawingControlOptions: {
        position: window.google.maps.ControlPosition.TOP_CENTER,
        drawingModes: [window.google.maps.drawing.OverlayType.POLYLINE]
      }
    })
    if (allTheDistances[key].mapHandler.polyline) {
      allTheDistances[key].mapHandler.polyline.setMap(null)
    }

    let items = [...allTheDistances]
    items[key].data.meters = 0
    items[key].data.coordinates = ""
    setAllTheDistances(items)
  }

  // Edit a polyline on a distance
  const editPolyline = function (key, distance, polyline) {
    const polyLengthInMeters =
      window.google.maps.geometry.spherical.computeLength(
        polyline.getPath().getArray()
      )
    let coordinates = JSON.stringify(polyline.getPath().getArray())

    distance.data.meters = polyLengthInMeters
    distance.data.coordinates = coordinates
    distance.mapHandler.polyline = polyline
    setCoordinates({
      key: key,
      update: distance
    })
  }

  // Save markers for species
  const saveMarkers = function (key) {
    let items = [...allTheDistances]
    items[key].data.inventory[currentInventory].species[
      currentSpeciesIndex
    ].markers = markers
    setAllTheDistances(items)
    markers = []
    setAddSpeciesToMapModalIsOpen(false)
  }

  const markersMap = (map, maps, key, distance) => {
    let coordinates = JSON.parse(distance.data.coordinates)
    let savedLine = new maps.Polyline({
      path: coordinates,
      geodesic: true,
      strokeColor: "#d979eb",
      strokeOpacity: 0.9,
      strokeWeight: 4,
      clickable: false
    })

    savedLine.setMap(map)
    savedLine.setEditable(false)

    var getMarkerUniqueId = function (lat, lng) {
      return lat + "_" + lng
    }

    var getLatLng = function (lat, lng) {
      return new window.google.maps.LatLng(lat, lng)
    }

    var bindMarkerEvents = function (marker, markerUniqueId) {
      window.google.maps.event.addListener(marker, "rightclick", function () {
        removeMarker(marker, markerUniqueId)
      })
    }

    var removeMarker = function (marker, markerUniqueId) {
      marker.setMap(null)
      let index = markers.find((x) => x.id == markerUniqueId)
      markers.splice(index, 1)
    }

    if (
      distance.data.inventory[currentInventory].species[currentSpeciesIndex]
        .markers !== undefined
    ) {
      distance.data.inventory[currentInventory].species[
        currentSpeciesIndex
      ].markers.forEach(function (value) {
        var lat = value.lat
        var lng = value.lng
        var markerId = getMarkerUniqueId(lat, lng)
        var marker = new window.google.maps.Marker({
          position: getLatLng(lat, lng),
          map: map,
          id: "marker_" + markerId
        })

        markers.push({
          id: markerId,
          lat,
          lng
        })

        bindMarkerEvents(marker)
      })
    }

    window.google.maps.event.addListener(map, "click", function (e) {
      var lat = e.latLng.lat()
      var lng = e.latLng.lng()
      var markerId = getMarkerUniqueId(lat, lng)
      var marker = new window.google.maps.Marker({
        position: getLatLng(lat, lng),
        map: map,
        id: "marker_" + markerId
      })
      markers.push({
        id: markerId,
        lat,
        lng
      })
      bindMarkerEvents(marker, markerId)
    })
  }

  function validateActivity() {
    if (!newActivityDate) {
      setNewActivityError(true)
      return false
    }

    if (!newActivityItem) {
      setNewActivityError(true)
      return false
    }

    return true
  }

  // Handle when loading Google Maps
  const handleApiLoaded = (map, maps, key, distance, editable = true) => {
    let savedLine = false
    let newDistance = Object.assign({}, distance)

    // Add drawing mode to the map
    let drawingManager = new maps.drawing.DrawingManager({
      drawingMode: maps.drawing.OverlayType.POLYLINE,
      drawingControl: true,
      drawingControlOptions: {
        position: maps.ControlPosition.TOP_CENTER,
        drawingModes: [maps.drawing.OverlayType.POLYLINE]
      },
      polylineOptions: {
        editable: true,
        strokeColor: "#d979eb",
        strokeOpacity: 0.9,
        strokeWeight: 4
      }
    })

    // Draw existing polyline to the map
    if (distance.data.coordinates.length > 0) {
      let savedCoordinates = JSON.parse(distance.data.coordinates)

      savedLine = new maps.Polyline({
        path: savedCoordinates,
        geodesic: true,
        strokeColor: "#d979eb",
        strokeOpacity: 0.9,
        strokeWeight: 4
      })

      savedLine.setMap(map)
      savedLine.setEditable(editable)

      drawingManager.setOptions({
        drawingControl: false,
        drawingMode: null,
        drawingControlOptions: {
          drawingModes: []
        }
      })
    }

    drawingManager.setMap(map)

    newDistance.mapHandler = {
      map: map,
      drawingManager: drawingManager,
      polyline: savedLine
    }

    setCoordinates({
      key: key,
      update: newDistance
    })

    // Saving a polyline
    window.google.maps.event.addListener(
      drawingManager,
      "polylinecomplete",
      function (polyline) {
        const polyLengthInMeters =
          window.google.maps.geometry.spherical.computeLength(
            polyline.getPath().getArray()
          )
        const coordinates = JSON.stringify(polyline.getPath().getArray())

        newDistance.data.meters = polyLengthInMeters
        newDistance.data.coordinates = coordinates
        newDistance.mapHandler.polyline = polyline

        setCoordinates({
          key: key,
          update: newDistance
        })

        window.google.maps.event.addListener(
          polyline.getPath(),
          "insert_at",
          function () {
            editPolyline(key, newDistance, polyline)
          }
        )

        window.google.maps.event.addListener(
          polyline.getPath(),
          "set_at",
          function () {
            editPolyline(key, newDistance, polyline)
          }
        )

        // Disable drawingManager when polyline is completed
        drawingManager.setOptions({
          drawingControl: false,
          drawingMode: null,
          drawingControlOptions: {
            drawingModes: []
          }
        })
      }
    )

    if (savedLine) {
      window.google.maps.event.addListener(
        savedLine.getPath(),
        "insert_at",
        function () {
          editPolyline(key, newDistance, savedLine)
        }
      )

      window.google.maps.event.addListener(
        savedLine.getPath(),
        "set_at",
        function () {
          editPolyline(key, newDistance, savedLine)
        }
      )
    }
  }

  function validateContactInfo() {
    if (pageType === "new") {
      setCurrentStep("add")
    }
  }

  // Save the contactinformation when edit
  async function saveContactInfo() {
    trigger() // Trigger the validation of the contactinformation form
    if (isValid) {
      setLoading(true)
      let contactInfo = getValues()
      await updateFlowerfieldContactInfo({
        contactInfo: contactInfo,
        token: token
      })
      setPageUpdatedSuccess(true)
      setLoading(false)
    }
  }

  // Save new flowerfields
  async function saveFlowerfield() {
    setLoading(true)
    const theDistances = allTheDistances.map((distance) => {
      return distance.data
    })
    await updateFlowerfield({
      distances: theDistances,
      token: token
    })
    // Show success message
    setPageUpdatedSuccess(true)
    setLoading(false)
  }

  function tryToLogin(e) {
    e.preventDefault()
    loadData("password", password)
  }

  function changeStep(step) {
    setPageUpdatedSuccess(false)
    trigger()

    if (isValid) {
      setCurrentStep(step)
    }
  }

  function addFiles(key, files) {
    setUploadErrors(false)

    if (allTheDistances[key].data.media.length > 4) {
      return false
    }

    files.forEach((file) => {
      if (parseInt(file.size) > 20480) {
        setUploadErrors("Bilden måste vara mindre än 20 Mb, försök igen")
        return
      }

      if (
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/webp"
      ) {
        let items = [...allTheDistances]
        items[key].data.media.push({
          id: 0,
          name: file.name,
          temp: URL.createObjectURL(file.file),
          size: file.size,
          base64: file.base64
        })
        setAllTheDistances(items)
      } else {
        setUploadErrors(
          "Bilden måste vara i följande filformat: jpg/jpeg, png eller webp"
        )
        return
      }
    })
  }

  function updateTitle(key, event) {
    let items = [...allTheDistances]
    items[key].data.title = event.target.value
    items[key].errors.title = false
    setAllTheDistances(items)
  }

  function updateDescription(key, event) {
    let items = [...allTheDistances]
    items[key].data.description = event.target.value
    items[key].errors.description = false
    setAllTheDistances(items)
  }

  function updateHasContacted(key) {
    let items = [...allTheDistances]
    items[key].data.hasContacted = !items[key].data.hasContacted
    items[key].errors.description = false
    setAllTheDistances(items)
  }

  function updateHasOrganization(key) {
    let items = [...allTheDistances]
    items[key].data.hasOrganization = !items[key].data.hasOrganization
    items[key].errors.description = false
    if (!items[key].data.hasOrganization) {
      items[key].data.organization = false
    }
    setAllTheDistances(items)
  }

  function updateType(key, event) {
    let items = [...allTheDistances]
    items[key].data.type = event.target.value
    items[key].errors.type = false
    setAllTheDistances(items)
  }

  function updateMunicipality(key, event) {
    let items = [...allTheDistances]
    items[key].data.municipality = event.target.value
    items[key].errors.municipality = false
    setAllTheDistances(items)
  }

  function updateIsMunicipality(key) {
    let items = [...allTheDistances]
    items[key].data.isMunicipality = !items[key].data.isMunicipality
    items[key].errors.description = false
    setAllTheDistances(items)
  }

  function updateIsWay(key) {
    let items = [...allTheDistances]
    items[key].data.isWay = !items[key].data.isWay
    items[key].errors.description = false
    setAllTheDistances(items)
  }

  function editDistance(key) {
    setCurrentDistance(key)
    setCurrentDistanceIndex(key)
    setCurrentDistanceIndex(key)
    setCurrentSpeciesIndex(key)
    setCurrentStep("add")
  }

  function showConfirm() {
    setSaveErrors(false)
    let errors = false

    if (allTheDistances.length === 0) {
      errors = true
    }

    allTheDistances.forEach((element, key) => {
      let distanceError = {}
      if (element.data.type === 0) {
        distanceError.type = true
      }
      if (element.data.status === 0) {
        distanceError.status = true
      }
      if (element.data.title === "") {
        distanceError.title = true
      }
      if (element.data.coordinates.length === 0) {
        distanceError.coordinates = true
      }
      if (element.data.hasOrganization && !element.data.organization) {
        distanceError.organization = true
      }

      if (Object.keys(distanceError).length > 0) {
        let items = [...allTheDistances]
        items[key].errors = distanceError
        setAllTheDistances(items)
        errors = true
      }
    })

    if (!errors) {
      setCurrentStep("confirm")
    } else {
      setSaveErrors(true)
    }
  }

  function updateStatus(key, event) {
    let items = [...allTheDistances]
    items[key].data.status = event.target.value
    items[key].errors.status = false
    setAllTheDistances(items)
  }

  function updateOrganization(key, event) {
    let items = [...allTheDistances]
    items[key].data.organization = event.target.value
    items[key].errors.organization = false
    setAllTheDistances(items)
  }

  function removeFile(key, index) {
    let items = [...allTheDistances]
    items[key].data.media.splice(index, 1)
    setAllTheDistances(items)
  }

  function addSpecies() {
    if (!selectedSpecies || !selectedFrequency) {
      return
    }

    let theSelectedSpecies = {}

    if (selectedSpecies === "custom") {
      theSelectedSpecies = {
        type: "custom",
        name: customSpecies,
        frequency: parseInt(selectedFrequency)
      }
    } else {
      theSelectedSpecies = {
        type: "list",
        specie_key: selectedSpecies,
        frequency: parseInt(selectedFrequency)
      }
    }

    let items = [...allTheDistances]

    items[currentDistanceIndex].data.inventory[
      currentInventory
    ].species.unshift(theSelectedSpecies)
    setAllTheDistances(items)
    setSelectedSpecies(0)
    setSelectedFrequency(0)
  }

  function deleteSpecies(key) {
    let items = [...allTheDistances]
    items[currentDistanceIndex].data.inventory[0].species.splice(key, 1)
    setAllTheDistances(items)
  }

  function editInventory(key) {
    setCurrentInventory(key)
  }

  function deleteInventory(key) {
    setCurrentInventory(-1)

    let items = [...allTheDistances]
    items[currentDistanceIndex].data.inventory.splice(key, 1)
    setAllTheDistances(items)
  }

  function addInventory(key) {
    if (currentInventoryDate == "") {
      return
    }

    let items = [...allTheDistances]

    if (items[key].data.inventory === null) {
      items[key].data.inventory = []
    }

    items[key].data.inventory.push({
      date: currentInventoryDate,
      species: [],
      soilProperties: [],
      adjacentLand: [],
      negativeImpact: [],
      otherInfo: "",
      files: []
    })

    setCurrentInventory(items[key].data.inventory.length - 1)
    setAllTheDistances(items)
  }

  function updateInventoryCheckbox(type, item) {
    let items = [...allTheDistances]
    if (
      !items[currentDistanceIndex].data.inventory[currentInventory][
        type
      ].includes(item.key)
    ) {
      items[currentDistanceIndex].data.inventory[currentInventory][type].push(
        item.key
      )
    } else {
      let index = items[currentDistanceIndex].data.inventory[currentInventory][
        type
      ].indexOf(item.key)
      items[currentDistanceIndex].data.inventory[currentInventory][type].splice(
        index,
        1
      )
    }

    setAllTheDistances(items)
  }

  function hasInventoryCheckbox(type, item) {
    if (
      allTheDistances[currentDistanceIndex].data?.inventory?.[
        currentInventory
      ]?.[type].indexOf(item.key) > -1
    ) {
      return true
    }
    return false
  }

  const submitDistances = async () => {
    errors = false

    let contactInfo = getValues()

    // Validate the maps
    if (allTheDistances.length === 0) {
      errors = true
    }

    allTheDistances.forEach((element, key) => {
      let distanceError = {}
      if (element.data.type === 0) {
        distanceError.type = true
      }
      if (element.data.status === 0) {
        distanceError.status = true
      }
      if (element.data.coordinates.length === 0) {
        distanceError.coordinates = true
      }

      if (Object.keys(distanceError).length > 0) {
        let items = allTheDistances
        items[key].errors = distanceError
        setAllTheDistances(items)
        errors = true
      }
    })

    if (errors) {
      return false
    }

    setLoading(true)
    const theDistances = allTheDistances.map((distance) => {
      return distance.data
    })

    const token = await recaptchaRef.current.executeAsync()

    const response = await addFlowerfield({
      distances: theDistances,
      contactInfo: {
        name: contactInfo.name,
        email: contactInfo.email,
        publicEmail: contactInfo.publicEmail
      },
      token
    })
    setLoading(false)
    setPassword(response.password)
    setCurrentStep("success")

    // Tracking
    pushDataLayer({
      event: "new_flowerfield"
    })
  }

  const typesText = {
    private: "Enskild väg",
    municipal: "Kommunal väg",
    state: "Statlig väg (endast länsstyrelse)"
  }

  const Tooltip = function (props) {
    return (
      <div className={styles.tooltip}>
        <div className={styles.info}>i</div>
        <span className={styles.tooltiptext}>{props.children}</span>
      </div>
    )
  }

  const customStyles = {
    overlay: {
      display: "flex",
      backgroundColor: "rgba(0, 0, 0, .5)",
      zIndex: 1000,
      alignItems: "center",
      justifyContent: "center"
    }
  }

  const allDistancesConfirm = allTheDistances.map((distance, key) => {
    return (
      <div
        key={"confirm-map-" + distance.id}
        className="flex flex-wrap pb-8 mb-10 border-b border-black-25 w-100">
        <div className="w-full pt-6 md:pt-0 md:w-1/2 md:pr-5">
          <h3 className="mb-2">{distance.data.title}</h3>

          <div className="flex mb-2">
            <button
              type="button"
              aria-label="Redigera"
              className="flex text-base font-bold underline"
              onClick={() => {
                editDistance(key)
              }}>
              <Edit className="w-6 h-6 mr-1" />
              Redigera
            </button>

            {(pageType === "update" ||
              (pageType === "new" && allTheDistances.length > 1)) && (
              <div
                className="ml-2 text-base font-bold underline cursor-pointer"
                onClick={() => {
                  deleteDistance(key)
                }}>
                Ta bort sträcka
              </div>
            )}
          </div>

          <strong>Väghållare</strong>
          <br />
          {typesText[distance.data.type]}
          <br />
          <br />

          <strong>Kommun</strong>
          <br />
          {distance.data.municipality}
          <br />
          <br />

          <strong>Kort beskrivning</strong>
          <br />
          {distance.data.description}
          <br />
          <br />
          {distance.data.hasContacted && (
            <>
              <Checkmark className="inline-block w-4 h-4 mr-2" />
              Har kontaktat väghållare
              <br />
            </>
          )}

          {distance.data.isWay && (
            <>
              <Checkmark className="inline-block w-4 h-4 mr-2" />
              Vägkanten är kopplad till en vägförening
              <br />
            </>
          )}

          {distance.data.isMunicipality && (
            <>
              <Checkmark className="inline-block w-4 h-4 mr-2" />
              Registrerar för kommunens räkning
              <br />
            </>
          )}

          {distance.data.hasOrganization && (
            <>
              <Checkmark className="inline-block w-4 h-4 mr-2" />
              Vägkanten är kopplad till kretsen {distance.data.organization}
              <br />
            </>
          )}

          <br />
          <strong>Uppladdade bilder</strong>
          <br />

          <div className="flex flex-wrap justify-between">
            {distance.data.media.map((element, index) => {
              return (
                <div
                  key={index}
                  className="relative flex items-center w-full p-4 mb-1 bg-green-10">
                  {element.temp && (
                    <img src={element.temp} className="w-10 h-auto mr-8" />
                  )}
                  {!element.temp && element.base64 && (
                    <img src={element.base64} className="w-10 h-auto mr-8" />
                  )}
                  {element.name}
                  <br />
                  {element.size} kb
                </div>
              )
            })}
          </div>
        </div>

        <div className="w-full pt-8 md:pl-5 md:w-1/2">
          <div className={styles.mapHolder}>
            <div className={styles.map}>
              <GoogleMapReact
                yesIWantToUseGoogleMapApiInternals
                key={distance.id}
                className="relative"
                bootstrapURLKeys={{
                  key: mapKey,
                  libraries: ["drawing"]
                }}
                center={{
                  lat: 59.36966,
                  lng: 16.510115
                }}
                zoom={7}
                onGoogleApiLoaded={({ map, maps }) =>
                  handleApiLoaded(map, maps, key, distance, false)
                }
                options={{
                  fullscreenControl: true,
                  zoomControl: true,
                  scrollwheel: true,
                  disableDefaultUI: true,
                  mapTypeId: "hybrid",
                  mapTypeControl: true
                }}
                disableDoubleClickZoom={true}></GoogleMapReact>
            </div>
          </div>
        </div>
      </div>
    )
  })

  const allDistances = allTheDistances.map((distance, key) => {
    if (currentDistance !== key) {
      return null
    }

    return (
      <div className="w-full" key={distance.id}>
        <div>
          <div className={styles.mapHolder}>
            <div className={styles.map}>
              <div
                className={styles.removePolyline}
                onClick={() => {
                  removePolyline(key)
                }}>
                Ta bort sträckan
              </div>
              <GoogleMapReact
                yesIWantToUseGoogleMapApiInternals
                key={distance.id}
                className="relative"
                bootstrapURLKeys={{
                  key: mapKey,
                  libraries: ["drawing"]
                }}
                center={{
                  lat: 59.36966,
                  lng: 16.510115
                }}
                zoom={7}
                onGoogleApiLoaded={({ map, maps }) =>
                  handleApiLoaded(map, maps, key, distance)
                }
                options={{
                  fullscreenControl: true,
                  zoomControl: true,
                  scrollwheel: true,
                  disableDefaultUI: true,
                  mapTypeId: "hybrid",
                  mapTypeControl: true
                }}
                disableDoubleClickZoom={true}></GoogleMapReact>
            </div>
          </div>

          {distance.errors.coordinates && (
            <span className="block pb-5 mt-3 text-xs text-red-100">
              En sträcka måste ritas ut
            </span>
          )}

          <div className="flex flex-wrap w-full">
            <div className="w-full md:pr-5 md:w-1/2">
              <div className="hidden">
                <InputGroup>
                  <label className={styles.label}>
                    Status på sträckan{" "}
                    <Tooltip>Ange en status på sträckan</Tooltip>
                  </label>

                  <div className={styles.selectWrapper}>
                    <select
                      value={distance.data.status}
                      className={styles.select}
                      onChange={(e) => updateStatus(key, e)}>
                      <option disabled value="0">
                        Välj status på sträckan
                      </option>
                      {status.map((status, index) => (
                        <option key={index} value={status.value}>
                          {status.name}
                        </option>
                      ))}
                    </select>
                    <Caret className={styles.caret} />
                  </div>

                  {distance.errors.status && (
                    <span className="mt-3 text-xs text-red-100">
                      En status måste väljas
                    </span>
                  )}
                </InputGroup>
              </div>
              <InputGroup>
                <label className={styles.label}>
                  Väghållare <Tooltip>Ange väghållare</Tooltip>
                </label>

                <div className={styles.selectWrapper}>
                  <select
                    value={distance.data.type}
                    className={styles.select}
                    onChange={(e) => updateType(key, e)}>
                    <option disabled value="0">
                      Välj väghållare
                    </option>
                    {types.map((type, index) => (
                      <option key={index} value={type.value}>
                        {type.name}
                      </option>
                    ))}
                  </select>
                  <Caret className={styles.caret} />
                </div>

                {distance.errors.type && (
                  <span className="mt-3 text-xs text-red-100">
                    En typ måste väljas
                  </span>
                )}
              </InputGroup>

              <InputGroup>
                <label className={styles.label}>
                  Namnge vägsträckan{" "}
                  <Tooltip>
                    Ange ett namn på sträckan. T.ex Storgatan i Enköping.
                  </Tooltip>
                </label>
                <input
                  className={styles.input}
                  placeholder="T.ex Storgatan i Enköping."
                  value={distance.data.title}
                  onChange={(event) => {
                    updateTitle(key, event)
                  }}
                />

                {distance.errors.title && (
                  <span className="mt-3 text-xs text-red-100">
                    Ett namn måste anges
                  </span>
                )}
              </InputGroup>

              <InputGroup>
                <label className={styles.label}>
                  Kommun{" "}
                  <Tooltip>Ange vilken kommun vägsträckan ligger i</Tooltip>
                </label>

                <div className={styles.selectWrapper}>
                  <select
                    value={
                      distance.data?.municipality
                        ? distance.data.municipality
                        : 0
                    }
                    className={styles.select}
                    onChange={(e) => updateMunicipality(key, e)}>
                    <option disabled value="0">
                      Välj kommun
                    </option>
                    {municipalities.map((value, index) => (
                      <option key={index} value={value}>
                        {value}
                      </option>
                    ))}
                  </select>
                  <Caret className={styles.caret} />
                </div>

                {distance.errors.type && (
                  <span className="mt-3 text-xs text-red-100">
                    En kommun måste välja
                  </span>
                )}
              </InputGroup>

              <InputGroup>
                <label className={styles.label}>
                  Kort beskrivning (Max 150 tecken){" "}
                  <Tooltip>
                    Ange ett kort beskrivning av sträckan på max 150 tecken
                  </Tooltip>
                </label>
                <textarea
                  className={styles.textarea}
                  placeholder="T.ex Gammal bortglömd skogsväg, delvis sandig, frekvent med blåklockor. Delvis igenvuxen med sly, vissa inslag av lupiner."
                  maxLength="300"
                  value={distance.data.description}
                  onChange={(event) => {
                    updateDescription(key, event)
                  }}
                />
              </InputGroup>

              <h4 className="mb-4">Vem/vilka står för skötsel av vägkanten?</h4>

              <InputGroup>
                <label className={styles.label}>
                  <input
                    type="checkbox"
                    value={!!distance.data.hasContacted}
                    onChange={() => updateHasContacted(key)}
                    className={checkboxStyles.checkbox}
                  />
                  <Checkbox checked={!!distance.data.hasContacted} />
                  <div className="text-sm md:text-base wysiwyg-content">
                    Markägare/ på uppdrag av markägare{" "}
                    <Tooltip>
                      Innan du påbörjar arbetet med din sträcka rekommenderar vi
                      att du kontaktar väghållaren (oftast en kommun,
                      privatperson, vägförening/samfällighet). På så sätt
                      säkerställer du att blommorna får stå kvar och sätta frö.
                    </Tooltip>
                  </div>
                </label>
              </InputGroup>

              <InputGroup>
                <label className={styles.label}>
                  <input
                    type="checkbox"
                    value={!!distance.data.isMunicipality}
                    onChange={() => updateIsMunicipality(key)}
                    className={checkboxStyles.checkbox}
                  />
                  <Checkbox checked={!!distance.data.isMunicipality} />
                  <div className="text-sm md:text-base wysiwyg-content">
                    Kommunen{" "}
                    <Tooltip>
                      Kommunen själv eller entreprenör på uppdrag av kommunen
                      sköter vägkanten.
                    </Tooltip>
                  </div>
                </label>
              </InputGroup>

              <InputGroup>
                <label className={styles.label}>
                  <input
                    type="checkbox"
                    value={!!distance.data.isWay}
                    onChange={() => updateIsWay(key)}
                    className={checkboxStyles.checkbox}
                  />
                  <Checkbox checked={!!distance.data.isWay} />
                  <div className="text-sm md:text-base wysiwyg-content">
                    En vägförening{" "}
                    <Tooltip>
                      Vägföreningen eller på entreprenör på uppdrag av
                      vägföreningen sköter vägkanten.
                    </Tooltip>
                  </div>
                </label>
              </InputGroup>

              <InputGroup>
                <label className={styles.label}>
                  {distance.data.hasOrganization}
                  <input
                    type="checkbox"
                    value={!!distance.data.hasOrganization}
                    onChange={() => updateHasOrganization(key)}
                    className={checkboxStyles.checkbox}
                  />
                  <Checkbox checked={!!distance.data.hasOrganization} />
                  <div className="text-sm md:text-base wysiwyg-content">
                    En lokal krets är engagerad i skötseln{" "}
                    <Tooltip>
                      Inom Naturskyddsföreningen finns ca 270 kretsar för lokalt
                      engagemang.
                    </Tooltip>
                  </div>
                </label>
              </InputGroup>

              {distance.data.hasOrganization !== undefined &&
                distance.data.hasOrganization && (
                  <>
                    <InputGroup>
                      <label className={styles.label}>
                        Välj krets:{" "}
                        <Tooltip>
                          Är arbetet med vägkanten kopplat till någon av
                          Naturskyddsföreningens kretsar?
                        </Tooltip>
                      </label>
                      <select
                        value={distance.data.organization}
                        className="block w-full py-2 pl-4 pr-8 text-lg leading-tight bg-white border rounded appearance-none border-black-50 focus:outline-none focus:shadow-outline"
                        onChange={(e) => updateOrganization(key, e)}>
                        <option value="">Välj krets</option>
                        {organizations.map((organization, index) => (
                          <option key={index} value={organization.value}>
                            {organization?.parent !== 0 && "– "}
                            {organization.label}
                          </option>
                        ))}
                      </select>

                      {distance.errors.organization && (
                        <span className="mt-3 text-xs text-red-100">
                          En krets måste väljas
                        </span>
                      )}
                    </InputGroup>
                  </>
                )}
            </div>

            <div className="flex flex-col w-full pt-10 md:w-1/2 md:pl-5 md:pt-0">
              <label className={styles.label}>
                Ladda upp bild
                <Tooltip>
                  Tillåta filformat: jpg/jpeg, png och webp.
                  <br />
                  Max 5 bilder.
                  <br />
                  Max storlek: 20mb
                </Tooltip>
              </label>
              {allTheDistances[key].data.media.length > 4 && (
                <div
                  className={
                    styles.fileholder +
                    " flex items-center justify-center flex-1 w-full mb-5 bg-green-5 py-14"
                  }>
                  Du kan max ladda upp 5 filer
                </div>
              )}

              {allTheDistances[key].data.media.length <= 4 && (
                <label
                  className={
                    styles.fileholder +
                    " flex flex-col items-center justify-center flex-1 w-full mb-5 bg-green-5 py-14"
                  }>
                  <div>Klicka för att ladda upp</div>
                  {uploadErrors && (
                    <div className="text-red-100">{uploadErrors}</div>
                  )}
                  <FileBase64
                    multiple={true}
                    onDone={addFiles.bind(this, key)}
                  />
                </label>
              )}
            </div>
          </div>
        </div>

        <label className={styles.label}>Uppladdade bilder</label>
        <div className="flex flex-wrap justify-between">
          {distance.data.media.length === 0 && (
            <i className="text-sm">Inga bilder uppladdade</i>
          )}

          {distance.data.media.map((element, index) => {
            return (
              <div key={index} className={styles.uploadedImage}>
                {element.temp && (
                  <img
                    src={element.temp}
                    className="h-auto mr-8 w-30 md:w-50"
                  />
                )}

                {!element.temp && element.base64 && (
                  <img
                    src={element.base64}
                    className="h-auto mr-8 w-30 md:w-50"
                  />
                )}
                {element.name}
                <br />
                {element.size}
                <div
                  className="absolute flex items-center justify-center w-10 h-10 cursor-pointer right-3 top-3"
                  onClick={() => {
                    removeFile(key, index)
                  }}>
                  <div className="flex items-center justify-center w-6 h-6 text-white rounded-full bg-black-100">
                    X
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  })

  // Template

  return (
    <>
      {currentStep === "login" && (
        <form onSubmit={tryToLogin} className="max-w-4xl mx-auto text-center">
          <h1 className="mb-4">Logga in</h1>
          <p className="mb-4">
            Logga in med den kod som du fick i bekräftelsemejlet.
          </p>
          <input
            className="inline-block p-6 mx-auto mb-10 text-2xl font-bold bg-green-25"
            onChange={(event) => {
              setPassword(event.target.value)
            }}
          />
          <div className="flex justify-center">
            <Button ariaLabel="Logga in" type="submit" theme="secondary">
              Logga in
            </Button>
          </div>
          <p className="mt-10">
            <strong>Glömt kod?</strong>
            <br />
            Kontakta oss på blomsterangar@naturskyddsforeningen.se så hjälper vi
            dig vidare.
          </p>
        </form>
      )}

      {!invalidToken && !login && (
        <Block className="flex flex-wrap bg-white md:p-12">
          {currentStep !== "success" && pageType === "new" && (
            <div className={styles.stepHeader}>
              <div
                className={styles.step}
                data-active={currentStep == "contact"}
                onClick={() => {
                  changeStep("contact")
                }}>
                <span>1.</span> Kontaktuppgifter
              </div>
              <div
                className={styles.step}
                data-active={currentStep == "add"}
                onClick={() => {
                  changeStep("add")
                }}>
                <span>2.</span> Lägg till sträcka
              </div>

              <div
                className={styles.step}
                data-active={currentStep == "confirm"}
                onClick={() => {
                  showConfirm()
                }}>
                <span>3.</span> Bekräftelse
              </div>
            </div>
          )}

          {pageType === "update" && (
            <div className={styles.stepHeader}>
              <div
                className={styles.step}
                data-active={currentStep == "contact"}
                onClick={() => {
                  changeStep("contact")
                }}>
                <span>1.</span> Kontaktuppgifter
              </div>
              <div
                className={styles.step}
                data-active={currentStep == "confirm"}
                onClick={() => {
                  changeStep("confirm")
                }}>
                <span>2.</span> Mina sträckor
              </div>
              <div
                className={styles.step}
                data-active={currentStep == "logout"}
                onClick={() => {
                  router.push("/kampanj/varldens-langsta-blomsterang/")
                }}>
                <span>3.</span> Logga ut
              </div>
            </div>
          )}

          {currentStep === "contact" && (
            <>
              <FormProvider {...methods}>
                <form
                  onSubmit={handleSubmit(validateContactInfo)}
                  id="form"
                  className="w-full mb-8 md:pr-6 md:w-1/2">
                  <div className="mb-6">
                    <h2>Varmt välkommen!</h2>
                    <p>
                      Din registrering är viktig, genom att registrera en
                      sträcka bidrar du till och är en del av en gemensam
                      satsning för omställning till en vägkantsskötsel som
                      gynnar biologisk mångfald och ett hållbart ekosystem.
                      <br />
                      <br />
                      Innan du registrerar en vägsträcka som du vill bevara
                      eller bidra till att den blir mer blomrik bör du ha tagit
                      reda på vem som sköter sträckan (enskild väg, kommunal
                      eller statlig) och känna till hur sträckan sköts i dag. Om
                      möjligt (beroende på säsong) identifiera gärna vilka arter
                      som finns längs sträckan och ett tips är att ta bilder som
                      sedan gärna får laddas upp i formuläret som följer. Det
                      går utmärkt att komplettera, redigera och följa upp din
                      sträcka i efterhand.
                      <br />
                      <br />
                      Vi hoppas att registreringen är början på ett långsiktigt
                      omställningsarbete för den aktuella sträckan men det finns
                      inget krav om uppföljning eller livslångt åtagande från
                      Världens längsta blomsteräng.
                    </p>
                  </div>

                  <div className={["component"].join(" ")}>
                    <div className="relative">
                      <InputGroup>
                        <Label name="name">Namn</Label>
                        <input
                          className={[
                            styles.input,
                            getInputValidationClasses("name", control)
                          ].join(" ")}
                          id="name"
                          placeholder="Vad heter du?"
                          {...register("name", {
                            required: true
                          })}
                        />
                        <ErrorMessage name="name" />
                      </InputGroup>

                      <InputGroup>
                        <Label name="email">E-post</Label>
                        <input
                          className={[
                            styles.input,
                            getInputValidationClasses("email", control)
                          ].join(" ")}
                          id="email"
                          placeholder="Din e-postadress"
                          {...register("email", {
                            required: true,
                            validate: (value) =>
                              isEmail(value) || "Ange en giltig e-postadress."
                          })}
                        />
                        <ErrorMessage name="email" />
                      </InputGroup>

                      <InputGroup>
                        <label htmlFor="publicEmail" className={styles.label}>
                          <input
                            type="checkbox"
                            id="publicEmail"
                            className={checkboxStyles.checkbox}
                            {...register("publicEmail")}
                          />
                          <Checkbox checked={publicEmail} />
                          <p className="inline text-sm md:text-base wysiwyg-content">
                            Jag vill att min e-postadress ska vara publik
                          </p>
                        </label>
                      </InputGroup>

                      <div
                        className="mb-6 text-sm md:text-base wysiwyg-content"
                        dangerouslySetInnerHTML={{
                          __html: block.attrs?.consent
                        }}></div>
                    </div>
                  </div>
                </form>
              </FormProvider>
              <div className="w-full md:pl-6 md:w-1/2">
                <img
                  className={styles.contactImage}
                  src="/flowerfields/vlba-logo.svg"
                />
              </div>
              <div className="flex justify-end w-full">
                {pageUpdatedSuccess && (
                  <div className="flex items-center mr-auto font-bold">
                    Kontaktuppgifter sparade!
                  </div>
                )}
                <div>
                  <Button
                    theme="light-green"
                    ariaLabel="Spara"
                    type="submit"
                    onClick={() => {
                      if (pageType === "new") {
                        changeStep("add")
                      } else {
                        saveContactInfo()
                      }
                    }}>
                    {pageType === "new" && <>Lägg till sträcka</>}
                    {pageType === "update" && <>Spara kontaktuppgifter</>}
                  </Button>
                </div>
              </div>
            </>
          )}

          {currentStep === "add" && (
            <>
              <div className="w-full mb-4">
                <h2>Sträcka</h2>
                <p className="mb-4">
                  Markera aktuell sträcka på kartan. Markeringen registrerar
                  längden och geografisk placering.
                </p>

                <h3>Så här gör du</h3>
                <ol className="mb-4">
                  <li>
                    1. Zooma in kartan till den vägsträcka du vill registrera.
                  </li>
                  <li>
                    2. Klicka för att börja markera sträckan, enkelklicka för
                    delpunkter, dubbelklicka på sista punkten för att avsluta
                    sträckmarkering.
                  </li>
                  <li>
                    3. Om något blir fel, klicka på &quot;Ta bort sträckan&quot;
                    och försök igen.
                  </li>
                  <li>
                    4. Du kan justera sträckan efter att du avslutat markeringen
                    genom att dra i punkterna.
                  </li>
                </ol>
              </div>

              <Modal
                isOpen={helpModalIsOpen}
                style={customStyles}
                shouldReturnFocusAfterClose={true}
                shouldCloseOnOverlayClick={true}
                className={classNames(modalStyles.content, "p-8")}>
                <h2>Hjälptext</h2>
                <ol>
                  <li>
                    1. Zooma in kartan till den vägsträcka du vill registrera.
                  </li>
                  <li>
                    2. Klicka för att börja markera sträckan, enkelklicka för
                    delpunkter, dubbelklicka på sista punkten för att avsluta
                    sträckmarkering.
                  </li>
                  <li>
                    3. Om något blir fel, klicka på &qout;Ta bort sträckan&qout;
                    och försök igen.
                  </li>
                  <li>
                    4. Du kan justera sträckan efter att du avslutat markeringen
                    genom att dra i punkterna.
                  </li>
                </ol>
                <div
                  className="absolute z-10 flex items-center justify-center p-2 text-black cursor-pointer right-1 top-1"
                  onClick={() => setHelpModalIsOpen(false)}>
                  <Close />
                </div>
              </Modal>

              <div className="w-1/2"></div>

              <div className="w-full mb-6">{allDistances}</div>
            </>
          )}

          {currentStep === "confirm" && (
            <div className="w-full">
              {allDistancesConfirm}

              <div className="flex flex-col-reverse justify-between w-full md:flex-row">
                <div className="w-full md:w-auto">
                  {pageType === "new" && (
                    <Button
                      theme="secondary"
                      ariaLabel="Tillbaka"
                      className="w-full mb-6 md:mb-0"
                      onClick={() => {
                        changeStep("add")
                      }}>
                      Tillbaka
                    </Button>
                  )}
                </div>
                <div className="flex flex-col-reverse w-full md:flex-row md:w-auto">
                  <Button
                    type="submit"
                    ariaLabel="Lägg till ny sträcka"
                    onClick={() => {
                      addNewDistance()
                      changeStep("add")
                    }}
                    theme="light-green"
                    className="w-full mb-4 mr-6 md:mb-0 md:w-auto">
                    Lägg till ny sträcka
                  </Button>
                  <ReCAPTCHA
                    className="hidden"
                    ref={recaptchaRef}
                    size="invisible"
                    sitekey={siteKey}
                  />
                  {pageType === "new" && (
                    <Button
                      type="submit"
                      ariaLabel="Skicka in"
                      onClick={() => {
                        submitDistances()
                      }}
                      theme="green"
                      className="mb-4 md:mb-0 md:w-auto">
                      Skicka in
                    </Button>
                  )}
                </div>
              </div>
            </div>
          )}

          {currentStep === "add" && (
            <>
              <div className="w-full bg-green-100 h-[1px] mt-4 mb-6"></div>

              <div className="w-full">
                <div className="w-full pt-6 mb-10 md:pt-0 md:w-2/4 md:pr-5">
                  <h2>Aktivitet</h2>
                  <p>
                    Aktiviteter är valfritt - Registrera gärna om det finns
                    genomförda eller planerade aktiviteter.
                  </p>
                </div>

                <div className="flex flex-wrap pb-8 mb-10 border-b border-black-25 w-100">
                  <div className="w-full pt-6 md:pt-0 md:w-2/4 md:pr-5">
                    <InputGroup>
                      <Label name="name">
                        Ange datum för aktivitet
                        <Tooltip>Ange datum för aktiviteten</Tooltip>
                      </Label>

                      <div className="flex items-start justify-start">
                        <div className="relative w-full">
                          <Datepicker
                            id="flower_activity_datepicker"
                            className={classNames([
                              styles.input,
                              styles.datepickerFull
                            ])}
                            onChange={(date) => {
                              date = new Date(date.dateInstance)
                              date.setMinutes(
                                date.getMinutes() - date.getTimezoneOffset()
                              )
                              setNewActivityDate(
                                date.toISOString().split("T")[0]
                              )
                            }}
                          />
                          <div className="absolute top-0 flex items-center h-full right-4">
                            <CalendarIcon className="cursor-pointer select-none" />
                          </div>
                        </div>
                      </div>
                    </InputGroup>

                    <InputGroup>
                      <Label name="activity">Aktivitet</Label>
                      <ActivityControl
                        options={distanceActivities}
                        selected={newActivityItem}
                        callback={(selectedValue) => {
                          setNewActivityItem(selectedValue)
                        }}
                      />
                    </InputGroup>

                    <div className="hidden">
                      <InputGroup>
                        <Label name="status" required={true}>
                          Status
                        </Label>
                        <div className="flex gap-10">
                          {activityStatuses.map((option, index) => (
                            <div key={index} className="relative pl-10">
                              <label className="text-base cursor-pointer whitespace-nowrap">
                                {option.label}
                                <input
                                  className="cursor-pointer h-6 w-6 absolute top-0.5 left-0 appearance-none rounded-full border border-solid border-black-100/20 before:pointer-events-none before:absolute before:h-6 before:w-6 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute after:z-[1] after:block after:h-6 after:w-6 after:rounded-full after:content-[''] checked:border-summer-green-100 checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-3 checked:after:w-3 checked:after:rounded-full checked:after:border-summer-green-100 checked:after:bg-summer-green-100 checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)]"
                                  type="radio"
                                  value={option.value}
                                  checked={newActivityStatus == option.value}
                                  name="activityStatus"
                                  onChange={(event) => {
                                    setNewActivityStatus(event.target.value)
                                  }}
                                />
                              </label>
                            </div>
                          ))}
                        </div>
                      </InputGroup>

                      <FileUpload
                        uploadedImages={newActivityUploads}
                        onChange={(file) => {
                          let items = [...newActivityUploads]
                          items.push({
                            name: file.name,
                            temp: URL.createObjectURL(file.file),
                            size: file.size,
                            base64: file.base64
                          })
                          setNewActivityUploads(items)
                        }}
                        onRemove={(index) => {
                          let items = [...newActivityUploads]
                          items.splice(index, 1)
                          setNewActivityUploads(items)
                        }}
                      />
                    </div>

                    <InputGroup>
                      <label className={styles.label}>
                        Beskriv aktiviteten{" "}
                        <Tooltip>
                          Beskriv gärna mer hur aktiviteten gick till.
                        </Tooltip>
                      </label>
                      <textarea
                        className={styles.textarea}
                        placeholder="Övrig information"
                        value={newActivityDescription}
                        onChange={(event) => {
                          setNewActivityDescription(event.target.value)
                        }}
                      />
                    </InputGroup>

                    {currentActivityIndex < 0 && (
                      <Button
                        type="button"
                        ariaLabel="Lägg till aktivitet"
                        theme="light-green"
                        onClick={() => {
                          if (!validateActivity()) {
                            return
                          }

                          let items = [...allTheDistances]

                          if (
                            items[currentDistanceIndex].data.activities === null
                          ) {
                            items[currentDistanceIndex].data.activities = []
                          }

                          items[currentDistanceIndex].data.activities.push({
                            date: newActivityDate,
                            activity: newActivityItem,
                            status: newActivityStatus,
                            files: newActivityUploads,
                            description: newActivityDescription
                          })
                          setAllTheDistances(items)
                          setNewActivityItem(0)
                          setNewActivityStatus("planned")
                          setNewActivityUploads([])
                          setNewActivityDescription("")
                        }}>
                        Lägg till aktivitet
                      </Button>
                    )}
                    {currentActivityIndex >= 0 && (
                      <>
                        <Button
                          type="button"
                          ariaLabel="Avbryt"
                          theme="secondary"
                          className="mr-6"
                          onClick={() => {
                            setNewActivityDate()
                            setNewActivityItem(0)
                            setNewActivityStatus("planned")
                            setNewActivityUploads([])
                            setNewActivityDescription()
                            setCurrentActivityIndex(-1)
                          }}>
                          Avbryt
                        </Button>

                        <Button
                          type="button"
                          ariaLabel="Spara"
                          theme="light-green"
                          onClick={() => {
                            if (!validateActivity()) {
                              return
                            }
                            let items = [...allTheDistances]
                            items[currentDistanceIndex].data.activities[
                              currentActivityIndex
                            ] = {
                              date: newActivityDate,
                              activity: newActivityItem,
                              status: newActivityStatus,
                              files: newActivityUploads,
                              description: newActivityDescription
                            }
                            setAllTheDistances(items)
                            setNewActivityItem(0)
                            setNewActivityStatus("planned")
                            setNewActivityUploads([])
                            setNewActivityDescription("")
                            setCurrentActivityIndex(-1)
                          }}>
                          Spara
                        </Button>

                        {newActivityError && (
                          <div className="w-full mt-4">
                            Du måste fylla i alla fält.
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  <div className="w-full pt-8 md:pl-5 md:w-2/4">
                    <h4>Valda aktiviteter</h4>

                    {allTheDistances[currentDistanceIndex].data?.activities
                      ?.length === 0 ||
                      (allTheDistances[currentDistanceIndex].data
                        ?.activities === null && (
                        <i className="text-sm">Inga valda aktiviteter</i>
                      ))}

                    <ul>
                      {allTheDistances[
                        currentDistanceIndex
                      ].data?.activities?.map((activity, index) => {
                        return (
                          <li
                            key={index}
                            className="pb-4 mt-4 mb-4 border-b border-solid border-black-25 last:border-none">
                            <div className="flex justify-between">
                              <div className="mr-4 flex-0">
                                <Icon svg={activity?.activity?.icon?.content} />
                              </div>
                              <div className="flex-auto">
                                <h5>{activity.activity.activity_name}</h5>
                                <p className="text-base">
                                  {activity.date} -{" "}
                                  {activity.status === "planned"
                                    ? "Planerad"
                                    : "Genomförd"}
                                </p>
                              </div>
                              <div className="flex items-center flex-0">
                                <button
                                  type="button"
                                  aria-label="Redigera"
                                  className="flex text-base font-bold underline"
                                  onClick={() => {
                                    setNewActivityError(false)
                                    setCurrentActivityIndex(index)
                                    setNewActivityItem(activity.activity)
                                    setNewActivityStatus(activity.status)
                                    setNewActivityUploads(activity.files)
                                    setNewActivityDescription(
                                      activity.description
                                    )
                                  }}>
                                  <Edit className="w-6 h-6 mr-1" />
                                  Redigera
                                </button>
                                <button
                                  type="button"
                                  aria-label="Ta bort"
                                  className="flex items-center justify-center w-6 h-6 ml-4 text-white rounded-full bg-black-100"
                                  onClick={() => {
                                    let items = [...allTheDistances]
                                    items[
                                      currentDistanceIndex
                                    ].data.activities.splice(index, 1)
                                    setAllTheDistances(items)
                                  }}>
                                  <Close className="w-2.5 h-2.5 fill-current" />
                                </button>
                              </div>
                            </div>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="w-full pt-6 mb-10 md:pt-0 md:w-2/4 md:pr-5">
                <h2>Inventering</h2>
                <p>
                  Inventering är valfri - Har du gjort en inventering,
                  registrera gärna växtfynd, markegenskaper m.m genom att klicka
                  på ”Lägg till en inventering”. Välkommen att ta hjälp av{" "}
                  <a href="https://www.naturskyddsforeningen.se/artiklar/floraguide-langs-vagar-i-sodra-sverige/">
                    Floraguiden för södra Sverige
                  </a>{" "}
                  eller{" "}
                  <a href="https://www.naturskyddsforeningen.se/artiklar/floraguide-langs-vagar-i-norra-och-mellersta-sverige/">
                    Lilla Floraguiden för mellersta/norra Sverige
                  </a>
                  .
                  <br />
                  <br />
                  Vill du göra en inventering?{" "}
                  <a href="https://www.naturskyddsforeningen.se/artiklar/startpaket-varldens-langsta-blomsterang/">
                    Beställ gärna ett startkit för protokoll och floraguide.
                  </a>
                </p>
              </div>

              <div className="flex flex-col w-full">
                <div className="flex flex-wrap pb-8 mb-10 border-b border-black-25 w-100">
                  <div className="w-full pt-6 md:pt-0 md:w-2/4 md:pr-5">
                    <InputGroup>
                      <Label name="name">
                        Ange datum för inventering
                        <Tooltip>
                          Det finns inget krav på att genomföra en inventering.
                          Vill du inventera din sträcka, beställa gärna ett
                          startkit som innehåller bland annat
                          inventeringsprotokoll och en floraguide som
                          underlättar vid inventeringen. Det räcker med ett
                          ungefärligt datum för perioden då inventeringen
                          genomfördes.
                        </Tooltip>
                      </Label>
                      <div className="flex flex-col items-start justify-start lg:flex-row">
                        <div className="relative w-full lg:max-w-[367px]">
                          <Datepicker
                            id="flower_datepicker"
                            className={classNames([
                              styles.input,
                              styles.datepicker
                            ])}
                            onChange={(date) => {
                              date = new Date(date.dateInstance)
                              date.setMinutes(
                                date.getMinutes() - date.getTimezoneOffset()
                              )
                              setCurrentInventoryDate(
                                date.toISOString().split("T")[0]
                              )
                            }}
                            placeholder="xxxx-xx-xx"
                          />
                          <div className="absolute top-0 flex items-center h-full right-6">
                            <CalendarIcon className="cursor-pointer select-none" />
                          </div>
                        </div>
                        <Button
                          className="w-full mt-4 lg:mt-0 md:ml-4 lg:w-auto"
                          theme="light-green"
                          ariaLabel="Lägg till inventering"
                          onClick={() => {
                            addInventory(currentDistanceIndex)
                          }}>
                          Lägg till inventering
                        </Button>
                      </div>
                    </InputGroup>
                  </div>
                  <div className="w-full pt-8 md:pl-5 md:w-2/4">
                    <h4>Tillagda inventeringar</h4>
                    {allTheDistances[currentDistanceIndex]?.data?.inventory
                      ?.length === 0 ||
                      (allTheDistances[currentDistanceIndex]?.data
                        ?.inventory === null && (
                        <i className="text-sm">Inga inventeringar gjorda</i>
                      ))}
                    <ul>
                      {allTheDistances[
                        currentDistanceIndex
                      ]?.data?.inventory?.map((item, index) => {
                        return (
                          <li className="flex justify-between mt-2" key={index}>
                            <div>{item.date}</div>

                            <div>
                              <div className="flex items-center mb-4 flex-0">
                                <button
                                  type="button"
                                  aria-label="Redigera"
                                  className="flex text-base font-bold underline"
                                  onClick={() => {
                                    editInventory(index)
                                  }}>
                                  <Edit className="w-6 h-6 mr-1" />
                                  Redigera
                                </button>
                                <button
                                  type="button"
                                  aria-label="Ta bort"
                                  className="flex items-center justify-center w-6 h-6 ml-4 text-white rounded-full bg-black-100"
                                  onClick={() => {
                                    deleteInventory(index)
                                  }}>
                                  <Close className="w-2.5 h-2.5 fill-current" />
                                </button>
                              </div>
                            </div>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                </div>

                {currentInventory >= 0 && (
                  <Modal
                    isOpen={currentInventory >= 0}
                    style={customStyles}
                    shouldReturnFocusAfterClose={true}
                    shouldCloseOnOverlayClick={true}
                    className={classNames(styles.modal)}>
                    <div className="flex flex-col w-full">
                      <div className={styles.modalHolder}>
                        <h2 className="mb-4">
                          Inventeringsprotokoll{" "}
                          <span className={styles.modalDate}>
                            {
                              allTheDistances[currentDistanceIndex].data
                                .inventory[currentInventory].date
                            }
                          </span>
                        </h2>
                        <h4></h4>

                        <Modal
                          isOpen={addSpeciesToMapModalIsOpen}
                          style={customStyles}
                          shouldReturnFocusAfterClose={true}
                          shouldCloseOnOverlayClick={true}
                          className={classNames(styles.speciesMap, "p-8")}>
                          <h2>Markera på kartan</h2>
                          <p className="mb-8">
                            Klicka på kartan för att markera var arten finns.{" "}
                            <br />
                            För att lägga till en markering klickar du med
                            vänster musknapp. <br /> För att ta bort klickar du
                            med höger musknapp på en markering.
                          </p>
                          <div className={styles.mapHolder}>
                            <div className={styles.map}>
                              <GoogleMapReact
                                yesIWantToUseGoogleMapApiInternals
                                key={distance.id}
                                className="relative"
                                bootstrapURLKeys={{
                                  key: mapKey,
                                  libraries: ["drawing"]
                                }}
                                center={
                                  allTheDistances[currentDistanceIndex].data
                                    .coordinates[0] !== undefined
                                    ? JSON.parse(
                                        allTheDistances[currentDistanceIndex]
                                          .data.coordinates
                                      )[0]
                                    : { lat: 0, lng: 0 }
                                }
                                zoom={16}
                                onGoogleApiLoaded={({ map, maps }) =>
                                  markersMap(
                                    map,
                                    maps,
                                    currentDistance,
                                    allTheDistances[currentDistanceIndex],
                                    false
                                  )
                                }
                                options={{
                                  fullscreenControl: true,
                                  zoomControl: true,
                                  scrollwheel: true,
                                  disableDefaultUI: true,
                                  mapTypeId: "hybrid",
                                  mapTypeControl: true
                                }}
                                disableDoubleClickZoom={true}></GoogleMapReact>
                            </div>
                          </div>

                          <Button
                            theme="light-green"
                            ariaLabel="Spara markeringar"
                            onClick={() => {
                              saveMarkers(currentDistanceIndex)
                            }}>
                            Spara markeringar
                          </Button>

                          <div
                            className="absolute z-10 flex items-center justify-center p-2 text-black cursor-pointer right-1 top-1"
                            onClick={() =>
                              setAddSpeciesToMapModalIsOpen(false)
                            }>
                            <Close />
                          </div>
                        </Modal>

                        <InputGroup>
                          <h5 className="mb-4">Markegenskaper</h5>
                          <div className="flex flex-row flex-wrap">
                            {soilProperties.map((item, index) => {
                              return (
                                <label
                                  key={index}
                                  className={cx(styles.label, "mr-6", "w-40")}>
                                  <input
                                    type="checkbox"
                                    value={item}
                                    onChange={() =>
                                      updateInventoryCheckbox(
                                        "soilProperties",
                                        item
                                      )
                                    }
                                    className={checkboxStyles.checkbox}
                                  />
                                  <Checkbox
                                    checked={hasInventoryCheckbox(
                                      "soilProperties",
                                      item
                                    )}
                                  />
                                  <p className="text-sm md:text-base wysiwyg-content">
                                    {item.label}
                                  </p>
                                </label>
                              )
                            })}
                          </div>
                        </InputGroup>

                        <InputGroup>
                          <h5 className="mb-4">Angränsande mark</h5>
                          <div className="flex flex-row flex-wrap">
                            {adjacentLand.map((item, index) => {
                              return (
                                <label
                                  key={index}
                                  className={cx(styles.label, "mr-6", "w-40")}>
                                  <input
                                    type="checkbox"
                                    value={item}
                                    onChange={() =>
                                      updateInventoryCheckbox(
                                        "adjacentLand",
                                        item
                                      )
                                    }
                                    className={checkboxStyles.checkbox}
                                  />
                                  <Checkbox
                                    checked={hasInventoryCheckbox(
                                      "adjacentLand",
                                      item
                                    )}
                                  />
                                  <p className="text-sm md:text-base wysiwyg-content">
                                    {item.label}
                                  </p>
                                </label>
                              )
                            })}
                          </div>
                        </InputGroup>

                        <InputGroup>
                          <h5 className="mb-4">Negativ påverkan</h5>
                          <div className="flex flex-row flex-wrap">
                            {negativeImpact.map((item, index) => {
                              return (
                                <label
                                  key={index}
                                  className={cx(styles.label, "mr-6", "w-40")}>
                                  <input
                                    type="checkbox"
                                    value={item}
                                    onChange={() =>
                                      updateInventoryCheckbox(
                                        "negativeImpact",
                                        item
                                      )
                                    }
                                    className={checkboxStyles.checkbox}
                                  />
                                  <Checkbox
                                    checked={hasInventoryCheckbox(
                                      "negativeImpact",
                                      item
                                    )}
                                  />
                                  <p className="text-sm md:text-base wysiwyg-content">
                                    {item.label}
                                  </p>
                                </label>
                              )
                            })}
                          </div>
                        </InputGroup>

                        <div className="w-full pt-6 mb-10 md:pt-0 md:w-2/4 md:pr-5">
                          <h2>Inventerade arter</h2>
                          <p>
                            Här kan du registrera de växter som du hittat vid
                            ett inventeringstillfälle. Ladda gärna upp bilder
                            från inventeringen! Om du vill bidra till kommunens,
                            länsstyrelsens och andra aktörers viktiga
                            naturvårdsarbete kan du dessutom rapportera in dina
                            fynd (alla eller särskilt intressanta arter) till{" "}
                            <a
                              target="_blank"
                              href="https://artportalen.se"
                              rel="noreferrer">
                              artportalen.se
                            </a>
                          </p>
                        </div>

                        <div className="flex flex-wrap pt-10 pb-8 mt-10 mb-10 border-t border-b border-black-25 w-100">
                          <div className="w-full pt-6 md:pt-0 md:w-2/4 md:pr-5">
                            <h5 className="mb-4">Lägg till art</h5>
                            <InputGroup>
                              <Label required={true} name="article">
                                Art
                              </Label>
                              <div className="relative w-full">
                                <select
                                  value={selectedSpecies}
                                  className="block w-full py-2 pl-4 pr-8 text-lg leading-tight bg-white border rounded appearance-none border-black-50 focus:outline-none focus:shadow-outline"
                                  onChange={(event) => {
                                    setSelectedSpecies(event.target.value)
                                  }}>
                                  <option value="0" disabled>
                                    Välj art
                                  </option>
                                  <option value="custom">Ange egen art</option>
                                  {species.map((species, index) => (
                                    <option
                                      key={index}
                                      value={species.specie_key}>
                                      {species.specie_name} (
                                      {species.specie_latin_name})
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
                                  <svg
                                    className="w-4 h-4 fill-current"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20">
                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                  </svg>
                                </div>
                              </div>
                            </InputGroup>

                            {selectedSpecies === "custom" && (
                              <InputGroup>
                                <Label name="email">Namn på art</Label>
                                <input
                                  className={styles.input}
                                  id="speciec_custom_name"
                                  placeholder="Ange namn på arten"
                                  value={customSpecies}
                                  onChange={(event) => {
                                    setCustomSpecies(event.target.value)
                                  }}
                                />
                              </InputGroup>
                            )}

                            <InputGroup>
                              <Label required={true} name="article">
                                Frekvens
                              </Label>
                              <div className="relative w-full">
                                <select
                                  value={selectedFrequency}
                                  className="block w-full py-2 pl-4 pr-8 text-lg leading-tight bg-white border rounded appearance-none border-black-50 focus:outline-none focus:shadow-outline"
                                  onChange={(event) => {
                                    setSelectedFrequency(event.target.value)
                                  }}>
                                  <option value="0" disabled>
                                    Frekvens
                                  </option>
                                  {frequencies.map((frequency, index) => (
                                    <option key={index} value={frequency.id}>
                                      {frequency.name}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
                                  <svg
                                    className="w-4 h-4 fill-current"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20">
                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                  </svg>
                                </div>
                              </div>
                            </InputGroup>

                            <Button
                              theme="light-green"
                              ariaLabel="Lägg till art"
                              onClick={() => {
                                addSpecies()
                              }}>
                              Lägg till art
                            </Button>
                          </div>

                          <Modal
                            isOpen={distanceError}
                            style={customStyles}
                            shouldReturnFocusAfterClose={true}
                            shouldCloseOnOverlayClick={true}
                            className={classNames(modalStyles.content, "p-8")}>
                            <h2 className="mb-4">Fel</h2>
                            För att markera en art på kartan behöver du först
                            rita ut en sträcka för vägkanten.
                            <Button
                              type="submit"
                              ariaLabel="Stäng"
                              onClick={() => {
                                setDistanceError(false)
                              }}
                              theme="light-green"
                              className="mb-4 md:mb-0 md:w-auto">
                              Stäng
                            </Button>
                            <div
                              className="absolute z-10 flex items-center justify-center p-2 text-black cursor-pointer right-1 top-1"
                              onClick={() => setDistanceError(false)}>
                              <Close />
                            </div>
                          </Modal>

                          <div className="w-full md:pl-5 md:w-2/4">
                            <h5 className="mb-4">Tillagda arter</h5>
                            {allTheDistances[
                              currentDistanceIndex
                            ].data.inventory[currentInventory].species.map(
                              (item, index) => (
                                <div
                                  key={index}
                                  className="pb-4 mb-4 border-b border-solid border-black-25 last:border-none">
                                  <div className="flex justify-between">
                                    <div className="mr-4 flex-0">
                                      <div className="flex items-center justify-center overflow-hidden rounded-full bg-green-10 w-17 h-17">
                                        <div className="relative w-full h-full">
                                          {item.type === "list" && (
                                            <SpeciesImage
                                              species={species}
                                              item={item}
                                            />
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex-auto">
                                      <h5>
                                        {item.type === "list" && (
                                          <>
                                            {
                                              species.find(function (x) {
                                                return (
                                                  x.specie_key ===
                                                  item.specie_key
                                                )
                                              }).specie_name
                                            }
                                          </>
                                        )}

                                        {item.type === "custom" && (
                                          <>{item.name}</>
                                        )}
                                      </h5>

                                      {item.type === "list" && (
                                        <i className="text-sm">
                                          (
                                          {
                                            species.find(function (x) {
                                              return (
                                                x.specie_key === item.specie_key
                                              )
                                            }).specie_latin_name
                                          }
                                          )
                                        </i>
                                      )}
                                      <p className="text-base">
                                        {
                                          frequencies.find(function (x) {
                                            return x.id === item.frequency
                                          }).name
                                        }
                                        <br />
                                        Markeringar på kartan:{" "}
                                        {item.markers !== undefined && (
                                          <div className={styles.numberCircle}>
                                            {Object.keys(item.markers).length}
                                          </div>
                                        )}
                                        {item.markers === undefined && (
                                          <div className={styles.numberCircle}>
                                            0
                                          </div>
                                        )}
                                      </p>
                                    </div>
                                    <div className="flex items-center flex-0">
                                      <button
                                        type="button"
                                        aria-label="Markera på karta"
                                        className="flex text-base font-bold underline"
                                        onClick={() => {
                                          if (
                                            allTheDistances[
                                              currentDistanceIndex
                                            ].data.coordinates.length
                                          ) {
                                            setCurrentSpeciesIndex(index)
                                            setAddSpeciesToMapModalIsOpen(true)
                                          } else {
                                            setDistanceError(true)
                                          }
                                        }}>
                                        <Edit className="w-6 h-6 mr-1" />
                                        Markera på karta
                                      </button>
                                      <button
                                        type="button"
                                        aria-label="Ta bort"
                                        className="flex items-center justify-center w-6 h-6 ml-4 text-white rounded-full bg-black-100"
                                        onClick={() => {
                                          deleteSpecies(index)
                                        }}>
                                        <Close className="w-2.5 h-2.5 fill-current" />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        </div>

                        <InputGroup>
                          <label className={styles.label}>
                            Övrig information{" "}
                            <Tooltip>
                              Skriv gärna in annan information, t.ex. noterade
                              insekter, invasiva arter, markegenskaper,
                              koordinater eller annat som du tycker är viktigt
                              att spara.
                            </Tooltip>
                          </label>
                          <textarea
                            className={styles.textarea}
                            placeholder="Övrig information"
                            value={
                              allTheDistances[currentDistanceIndex].data
                                .inventory[currentInventory].otherInfo
                            }
                            onChange={(event) => {
                              let items = [...allTheDistances]
                              items[currentDistanceIndex].data.inventory[
                                currentInventory
                              ].otherInfo = event.target.value
                              setAllTheDistances(items)
                            }}
                          />
                        </InputGroup>

                        <FileUpload
                          uploadedImages={
                            allTheDistances[currentDistanceIndex].data
                              .inventory[currentInventory].files
                          }
                          onChange={(file) => {
                            let items = [...allTheDistances]
                            items[currentDistanceIndex].data.inventory[
                              currentInventory
                            ].files.push({
                              name: file.name,
                              temp: URL.createObjectURL(file.file),
                              size: file.size,
                              base64: file.base64
                            })
                            setAllTheDistances(items)
                          }}
                          onRemove={(index) => {
                            let items = [...allTheDistances]
                            items[currentDistanceIndex].data.inventory[
                              currentInventory
                            ].files.splice(index, 1)
                            setAllTheDistances(items)
                          }}
                        />

                        <Button
                          theme="light-green"
                          ariaLabel="Spara inventering"
                          onClick={() => {
                            setCurrentInventory(-1)
                          }}>
                          Spara inventering
                        </Button>
                      </div>
                    </div>
                  </Modal>
                )}
                <div className="flex flex-col-reverse justify-between w-full md:flex-row">
                  <div>
                    <Button
                      theme="secondary"
                      ariaLabel="Tillbaka"
                      className="w-full mb-8 md:mb-0"
                      onClick={() => {
                        if (pageType === "new") {
                          changeStep("contact")
                        } else {
                          changeStep("confirm")
                        }
                      }}>
                      Tillbaka
                    </Button>
                  </div>
                  {pageUpdatedSuccess && (
                    <div className="flex items-center font-bold">
                      Sträckan sparad!
                    </div>
                  )}

                  {saveErrors && (
                    <div className="flex items-center font-bold">
                      Formuläret innehåller fel, kontrollera och skicka in igen.
                    </div>
                  )}

                  <Button
                    type="submit"
                    ariaLabel="Spara"
                    onClick={() => {
                      if (pageType === "update") {
                        saveFlowerfield()
                      } else {
                        showConfirm()
                      }
                    }}
                    theme="light-green"
                    className="mb-6 md:mb-0">
                    {pageType === "new" && <>Nästa</>}
                    {pageType === "update" && <>Spara sträcka</>}
                  </Button>
                </div>
              </div>
            </>
          )}

          {currentStep === "success" && (
            <div className="max-w-4xl mx-auto text-center">
              <img
                src="/flowerfields/vlba-logo.gif"
                className="w-full max-w-xl px-10 mx-auto mb-4 lg:mb-10"
              />
              <h1 className="mb-4">Stort tack för din registrering!</h1>
              <p className="mb-4">
                Stort tack för din registrering! Så snart sträckan är godkänd
                skickas ett mejl till den angivna adressen. Din sträcka syns då
                som en klickbar blomma på kartan. Där finns informationen om
                sträckan som ett eget kort.
                <br />
                <br />
                Inspirera gärna fler i din omgivning att engagera sig genom att
                dela länken för ditt kort och eventuella aktiviteter
                <br />
                <br />
                Har du frågor? Mejla oss på &nbsp;
                <a href="mailto:blomsterangar@naturskyddsforeningen.se">
                  blomsterangar@naturskyddsforeningen.se
                </a>
              </p>
              <div className="inline-block p-6 mx-auto mb-10 text-2xl font-bold bg-green-25">
                {password}
              </div>
              <div className="flex justify-center w-full">
                <Button
                  type="button"
                  ariaLabel="Till startsidan"
                  theme="green"
                  onClick={() => {
                    router.push("/kampanj/varldens-langsta-blomsterang/")
                  }}>
                  Till startsidan
                </Button>
              </div>
              <br />
              <strong>Vill du göra mer?</strong>
              <p className="mb-8 lg:mb-0">
                <a href="https://www.naturskyddsforeningen.se/stod-oss/bli-medlem/">
                  Bli medlem i Sveriges största miljöorganisation här.
                </a>
              </p>
            </div>
          )}
        </Block>
      )}
      {invalidToken && (
        <div>
          <h1>Felaktig token!</h1>
        </div>
      )}

      {invalidPassword && (
        <Block width="column">
          <h3 className="mt-8 text-center">Felaktigt lösenord!</h3>
          <p className="text-center">Försök igen</p>
        </Block>
      )}
      {loading && (
        <div className={styles.loading}>
          <div className="flex flex-col items-center">
            <Spinner className="mb-4"></Spinner>
            <h3>Laddar</h3>
          </div>
        </div>
      )}
    </>
  )
}

const Icon = ({ svg, className }) => {
  return (
    <div
      className={classNames(
        "icon fill-white w-10 h-10 md:w-12 md:h-12 bg-summer-green-100 rounded-full p-1.5",
        className
      )}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  )
}

const SpeciesImage = ({ species, item }) => {
  let image = species.find(function (x) {
    return x.specie_key === item.specie_key
  }).specie_image

  if (image === null || image === undefined) {
    return null
  }

  return (
    <Image
      src={image}
      layout="fill"
      objectFit="fill"
      objectPosition="center"
      className="round"
    />
  )
}
